<template lang="pug">
  .form-test-settings
    .columns.is-multiline
      .column.is-6-tablet.is-6-desktop
        b-field(label="Ограничение по времени (минуты)")
          b-field
            b-switch(v-model="allowTime" :true-value="1" :false-value="0")
            b-input(v-model="value.time_limit" :disabled="!allowTime")

    .columns.is-multiline
      .column.is-4-tablet.is-4-desktop
        ui-field(type="number" step="0.1" min="0" max="100" label="Баллы для прохождения теста" v-model="value.need_scores" :error="errors.need_scores" rules="required|between:0,100" message="Минимальное кол-во правильных ответов для прохождения теста")

      .column.is-4-tablet.is-4-desktop
        ui-field(
          type="number"
          label="Количество задаваемых вопросов"
          v-model="value.shown_questions_count"
          :error="errors.shown_questions_count"
          min="0" :max="value.questions.count()"
          rules="numeric"
          message="Кол-во вопросов которое будет задано испытуемому из всего списка вопросов"
        )

    //- ui-field(
    //-   type="switch"
    //-   label="Вопросы в случайном порядке"
    //-   v-model="value.questions_in_random_order"
    //-   :error="errors.questions_in_random_order"
    //- )


    b-field(label="Количество попыток")
      b-field
        b-radio-button(
          v-for="count in repeatVariants"
          :key="count"
          v-model="value.attempts_count"
          :native-value="count"
        ) {{count}}
        b-radio-button(v-model="value.attempts_count" :native-value="0"): b-icon.is-marginless(icon="infinity")
    b-field(label="Прочие настройки")
      b-switch(v-model="value.questions_in_random_order" :true-value="1" :false-value="0")
        | Вопросы в случайном порядке
    b-field: b-switch(v-model="value.can_change_answer" :true-value="1" :false-value="0")
        | Возможность изменять ответ
    b-field: b-switch(v-model="value.commentable" :true-value="1" :false-value="0")
        |  Разрешает оставить комментарий после завершения тестирования.

</template>

<script>
export default {
  name: 'form-test-settings',

  props: {
    value: null,
    errors: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      allowTime: this.value.time_limit ? 1 : 0,
      repeatVariants: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    };
  },
};
</script>
